import "./App.css";
import axios from "axios";
import Cookies from "js-cookie";
import { socket } from "./socket";
import { v4 as uuidv4 } from "uuid";
import { messaging } from "./firebase";
import { useEffect, useRef, useState } from "react";
import activeTab from "src/assets/activeTab.png";
import CONSTANTS from "./components/services/api";
import { useSearchParams } from "react-router-dom";
import AppHeader from "./components/layout/AppHeader";
import { toast, ToastContainer } from "react-toastify";
import { getToken, onMessage } from "firebase/messaging";
import { MyContext } from "./components/Context/MyContext";
import AppContainer from "./components/layout/AppContainer";
import AdminDashboard from "./components/pages/AdminDashboard";
import UserNotFound from "./components/molecules/UserNotFound";
import loaderAnimation from "src/assets/loaderAnimation.gif";

import {
  manuallyActivateTab,
  useActiveTabGuard,
  useSingleActiveTab,
  useSingleTabGuard,
} from "./services/functions/ControlMultipleTabs";

function App() {
  const [searchParams] = useSearchParams();
  const [userInfo, setUserInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [FcmToken, setFcmToken] = useState(null);
  const [selectedChat, setSelectedChat] = useState(null);
  const [bearerToken, setBearerToken] = useState(null);
  const [error, setError] = useState(null);
  const [deeplinkId, setDeeplinkId] = useState(null);
  const [userId, setUserId] = useState("");
  const cokiesUserId = Cookies.get("user_id");

  async function requestPermission() {
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BH42wRU2deIMh2cYYxlMztsy0IuuCQfyH70mX6Rs5tgfo25cFOMK3H3vEWi7BONtTdzUCJ03NnCQBn8WztkEfgg",
      });
      // console.log("Token generated >++++++++++++> ", token);
      setFcmToken(token);
    } else if (permission === "denied") {
      alert("You denied for the notification");
    }
  }

  // For disconnect the socket connection
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue = ""; // This shows the browser confirmation dialog
  //     socket.emit("new-disconnect", { socketId: socketIdRef.current });
  //   };
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  useEffect(() => {
    const showChat = JSON.parse(localStorage.getItem("showChat"));
    localStorage.setItem("my-message", JSON.stringify([]));
    if (showChat) {
      localStorage.removeItem("showChat");
    }
    requestPermission();
  }, []);

  useEffect(() => {
    onMessage(messaging, (payload) => {
      if (document.visibilityState !== "visible") return;
      const showChat = JSON.parse(localStorage.getItem("showChat"));

      const title = payload?.data?.title || "IMWOW";
      const message = payload?.data?.message || "You have a new message";
      const icon = payload?.data?.icon || "/icons/logo.png";
      const audio = new Audio("/icons/whatsapp_notification.mp3");
      audio.play().catch((err) => {
        console.warn("Failed to play sound:", err);
      });
      if (message) {
        if (!(String(showChat?._id) === String(payload?.data?.enrollment_id))){
          toast(
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img
                src={icon}
                alt="icon"
                style={{ width: "30px", height: "30px", borderRadius: "6px" }}
              />
              <div className=" ml-3">
                <strong>{title}</strong>
                <div>{message}</div>
              </div>
            </div>,
            {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "dark",
              style: {
                maxHeight: "100px",
                minWidth: "300px",
              },
            }
          );
        }
        
      }
    });
  }, []);

  // for remove the right click from app
  // useEffect(() => {
  //   document.addEventListener('contextmenu', (e) => e.preventDefault());
  // },[]);

  useEffect(() => {
    socket.on("connect", (message) => {
      socket.on("socket-connected", (msg) => {
        // console.log("socket-connected >>>>", msg.id);
      });
    });
    socket.on("disconnect", () =>
      console.log("<<<<<<<<<< Socket disconnect >>>>>>>")
    );
  }, []);

  useEffect(() => {
    if(userId ){
      socket.emit("new-connected", { userId: userId,platform: "Web" });
    }
  },[userId]);

  useEffect(() => {
    const handleSWMessage = (event) => {
      const payload = event.data; // <- Fix is here
      if (payload?.type === "chat") {
        const enrollment_id = payload.enrollment_id;
        openChat(enrollment_id);
      }
    };
    navigator.serviceWorker?.addEventListener("message", handleSWMessage);
    return () => {
      navigator.serviceWorker?.removeEventListener("message", handleSWMessage);
    };
  }, []);
  const openChat = (id) => {
    setDeeplinkId(id);
  };

  async function getCoachDetails() {
    setLoading(true);
    if (cokiesUserId) {
      try {
        const { data } = await axios.post(
          `${CONSTANTS.API_BASE}/getCoachDetails`,
          {
            user_id: cokiesUserId,
            device_id: uuidv4(),
            platform: "Web",
            app_version: "1.0",
            fcm_token: FcmToken,
          }
        );
        if (!data) return;
        setUserInfo(data);
        setUserId(String(data?.user_id));
        Cookies.set("Token", `Bearer ${data?.api_token}`);
        setBearerToken(`Bearer ${data?.api_token}`);
        Cookies.set("roleId", String(data?.role_id));
        Cookies.set("name", data?.name);
        Cookies.set("profile_pic", data?.pro_pic_url);
      } catch (error) {
        console.log("Error >>>", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    getCoachDetails();
  }, [FcmToken]);

  useEffect(() => {
    // Store initial user_id from cookies
    const initialUserId = getCookieValue("user_id");
    localStorage.setItem("initial_user_id", initialUserId);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const currentUserId = getCookieValue("user_id");
        const initialStoredId = localStorage.getItem("initial_user_id");

        if (!currentUserId) {
          window.location.reload(); // logged out
        } else if (currentUserId !== initialStoredId) {
          window.location.reload(); // user switched
        } else {
        }
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const getCookieValue = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  function chatActiveCondition() {
    return (
      <div className=" text-center flex justify-center w-screen h-screen text-black font-bold items-center bg-white ">
        <div className="   flex flex-col justify-center items-center ">
          <img src={activeTab} alt="active image" />
          <h1 className="text-[38px] -mt-16 font-semibold">
            Chat is active in another tab{" "}
          </h1>
          <h5 className="text-[16px] font-semibold text-[#76767CCC] ">
            Switch back or click button to active here{" "}
          </h5>
          <button
            onClick={manuallyActivate}
            className="bg-[#63BE5F] text-white px-2 text-sm shadow-sm shadow-gray-300 py-2 rounded-sm mt-4 hover:bg-[#6ede7b] transition duration-300 ease-in-out"
          >
            Active Chat
          </button>
        </div>
      </div>
    );
  }

  function ErrorPage() {
    return (
      <>
        {error ? (
          <div className=" text-center flex justify-center w-full h-screen text-black font-bold items-center bg-white flex-col">
            <h1 className="text-[38px] font-semibold">Something went wrong</h1>
            <h5 className="text-[16px] font-semibold text-[#76767CCC] ">
              Please try again later
            </h5>
          </div>
        ) : null}
      </>
    );
  }

  const { isActiveTab, manuallyActivate } = useSingleActiveTab();

  return (
    <>
      {error ? (
        ErrorPage()
      ) : !isActiveTab ? (
        chatActiveCondition()
      ) : (
        <div className="flex md:flex-col items-center justify-center">
          <ToastContainer position="top-center" />
          {!(userId || cokiesUserId) ? (
            <>
              <AppHeader />
              <UserNotFound />
            </>
          ) : (
            <MyContext.Provider
              value={{ socket, selectedChat, setSelectedChat, userInfo, deeplinkId ,setDeeplinkId, userId}}
            >
              <AppHeader loading={loading} />
              <AppContainer>
                {bearerToken ? (
                  <AdminDashboard bearerToken={bearerToken} />
                ) : !error ? (
                  <div className="flex justify-center items-center h-full w-full">
                    <img src={loaderAnimation} alt="loader" />
                  </div>
                ) : null}
              </AppContainer>
            </MyContext.Provider>
          )}
        </div>
      )}
    </>
  );
}

export default App;
